import React from 'react';
import { Users } from 'lucide-react';

export default function ProgressBar({ current, target, className = '' }) {
  const pct = Math.min((current / target) * 100, 100);
  const reached = current >= target;

  return (
    <div className={className}>
      <div className="flex items-center justify-between mb-1.5">
        <div className="flex items-center gap-1.5 text-sm text-slate-700">
          <Users className="w-4 h-4" />
          <span className="font-medium">{current}</span>
          <span className="text-slate-500">/ {target}</span>
        </div>
        {reached && (
          <span className="text-[10px] font-semibold text-emerald-600 bg-emerald-500/15 px-2 py-0.5 rounded-full border border-emerald-500/30">
            Objectif atteint
          </span>
        )}
      </div>
      <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-700 ${reached ? 'bg-emerald-500' : 'bg-secondary'}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
